import EducationCertificates from './EducationCertificates.component';

export default EducationCertificates;